import { useRef } from "react"

import ActionItems from "components/admin/StripeAccountNotificationBanner/ActionItems"
import Banner from "components/admin/StripeAccountNotificationBanner/Banner"
import useSessionStorage from "hooks/use_session_storage"
import useStripeConnectInstance from "hooks/use_stripe_connect_instance"
import useStripeInfo from "hooks/use_stripe_info"

const NotificationBanner = () => {
  const { accountId } = useStripeInfo()
  const { isTestModeMismatch } = useStripeConnectInstance()

  const dialogRef = useRef(null)
  const [stripeNotificationCount, setStripeNotificationCount] = useSessionStorage(
    `stripe_notification_count_${accountId}`,
    null
  )
  const hasNotifications = stripeNotificationCount > 0

  const handleOpenDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal()
    }
  }

  const handleNotificationsChange = count => {
    setStripeNotificationCount(count)
  }

  if (isTestModeMismatch) {
    return (
      <Banner>
        Your Stripe account supports live mode, but it&apos;s being used in test mode. Please use a
        test mode-only Stripe account for testing.
      </Banner>
    )
  } else {
    return (
      <>
        {hasNotifications && (
          <Banner onActionClick={handleOpenDialog}>
            We&apos;ve detected a critical issue with your Stripe account that prevents Planning
            Center from processing online payments.{" "}
          </Banner>
        )}
        <ActionItems dialogRef={dialogRef} onNotificationsChange={handleNotificationsChange} />
      </>
    )
  }
}

export default NotificationBanner
